import { ReactNode, useMemo } from 'react'
import { ThemeProvider as MuiThemeProvider, CssBaseline, createTheme } from '@mui/material'
import { useUIStore } from '@store/uiStore'
import { themeRegistry } from '@themes/registry'

interface ThemeProviderProps {
  children: ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const { themeName, themeMode } = useUIStore()

  const theme = useMemo(() => {
    // Get theme config from registry
    const themeConfig = themeRegistry.getTheme(themeName) || themeRegistry.getTheme('default')!

    // Select light or dark mode
    const themeOptions = themeMode === 'dark' ? themeConfig.dark : themeConfig.light

    // Create MUI theme
    return createTheme(themeOptions)
  }, [themeName, themeMode])

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  )
}
